
export const handleChange = (fileObject) => {
  const file = fileObject;
  if (file) {
    let formData = new FormData();
    formData.append("file", file);
    return formData;
  }
};
